import type { Locale } from '@fv/models'

import { useAppSettings } from './settings/useAppSettings'

export function useLocale(): Locale {
  const settingsQuery = useAppSettings()
  return settingsQuery.data?.locale || 'en-US'
}
